"use client";

import { c as _c } from "react/compiler-runtime";
import { type ChangeEvent, useCallback, useState } from "react";
import { commentConfig } from "@/components/Comment/config/comment.config";
type UseCharacterCountReturn = {
  readonly charCount: number;
  readonly isAtLimit: boolean;
  readonly maxLength: number;
  readonly handleChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  readonly reset: () => void;
};
export function useCharacterCount() {
  const $ = _c(5);
  const [charCount, setCharCount] = useState(0);
  const {
    maxLength
  } = commentConfig.form;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = e => {
      setCharCount(e.target.value.length);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleChange = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setCharCount(0);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const reset = t1;
  const isAtLimit = charCount >= maxLength;
  let t2;
  if ($[2] !== charCount || $[3] !== isAtLimit) {
    t2 = {
      charCount,
      handleChange,
      isAtLimit,
      maxLength,
      reset
    };
    $[2] = charCount;
    $[3] = isAtLimit;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}